import { CreateElement } from 'vue'
import { RouteConfig, Route } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { lkPublicationPermissions as Permissions } from '@/helpers/enums/permission-models'
import * as TYPES from '@/helpers/enums/view-types'
import { COLLECTOR_PUBLICATIONS_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_COLLECTOR_PUBLICATIONS } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'publications',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule, collectorPublicationsStoreModule } = await import(
        /* webpackChunkName: "publications.store" */
        './store'
      )
      registerModule(options)
      // Ужас
      const store = collectorPublicationsStoreModule.context(options.store)


      const promises = [
        store.actions.fetchSessions(),
        store.actions.fetchSubjects(),
        store.actions.fetchProcedures(),
        store.actions.fetchEvents(),
      ]

      await Promise.all(promises)

      next()
    },
    component: {
      name: 'view-publications-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "publications.list" */
          './PublicationsList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permission: Permissions.read,
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "publications.view" */
          './PublicationsView.vue'
        ),
      },
      {
        path: ':id(\\d+)/edit',
        name: ROUTES.EDIT,
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
        meta: {
          permission: Permissions.edit,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "publications.view" */
          './PublicationsView.vue'
        ),
      },
      {
        path: 'create',
        name: ROUTES.CREATE,
        props: () => ({ viewType: TYPES.CREATE }),
        meta: {
          permission: Permissions.create,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "publications.view" */
          './PublicationsView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
